import React, { useState, useRef } from 'react';
import { gsap } from 'gsap';
import './FullWidthVideo.scss';

interface VideoItem {
  id: string;
  vimeoId: string;
  thumbnail: string;
  title: string;
}

// JSON array of video objects
const videoData: VideoItem[] = [
  {
    id: '1',
    vimeoId: '1128872045',
    thumbnail: '/images/videos/ADM_Showreel_feature_Focus Group.webp',
    title: 'Video 5'
  },
  {
    id: '2',
    vimeoId: '1128877491',
    thumbnail: '/images/videos/ADM_Showreel_feature_Marsh and Parsons.webp',
    title: 'Video 4'
  },
  {
    id: '3',
    vimeoId: '1128878893',
    thumbnail: '/images/videos/ADM_Showreel_feature_Sokito.webp',
    title: 'Video 2'
  },
  {
    id: '4',
    vimeoId: '1128876886',
    thumbnail: '/images/videos/ADM_Showreel_feature_Fine Cell Work.webp',
    title: 'Video 3'
  },
  {
    id: '5',
    vimeoId: '1128879518',
    thumbnail: '/images/videos/ADM_Showreel_feature_The Considered Ask.webp',
    title: 'Video 1'
  },
  {
    id: '6',
    vimeoId: '1128877890',
    thumbnail: '/images/videos/ADM_Showreel_feature_Orbzii.webp',
    title: 'Video 6'
  }
];

const FullWidthVideo: React.FC = () => {
  const [currentVideo, setCurrentVideo] = useState<VideoItem>(videoData[0]);
  const [isPlaying, setIsPlaying] = useState<boolean>(false);
  const [isVideoLoaded, setIsVideoLoaded] = useState<boolean>(false);

  // Debug logging
  console.log('Current video:', currentVideo);
  console.log('Is video loaded:', isVideoLoaded);
  console.log('Thumbnail path:', currentVideo.thumbnail);

  const handleVideoClick = (video: VideoItem) => {
    // Don't transition if it's the same video
    if (video.id === currentVideo.id) return;

    // Stop current video
    setIsPlaying(false);
    setIsVideoLoaded(false);

    // Simple video change without animations
    setCurrentVideo(video);
    setIsPlaying(true);
    setIsVideoLoaded(true);
  };

  const handleMainVideoClick = () => {
    if (!isPlaying) {
      setIsPlaying(true);
      setIsVideoLoaded(true);
    }
  };


  return (
    <section className="full-width-video">
      <div className="video-container">
        <div className="video-wrapper" onClick={handleMainVideoClick}>
          <div className="video-content">
            {/* Thumbnail background - visible when video is not loaded */}
            {!isVideoLoaded && (
              <div className="video-thumbnail">
                <img 
                  src={currentVideo.thumbnail} 
                  alt={currentVideo.title}
                  style={{
                    width: '100%',
                    height: '100%',
                    objectFit: 'cover'
                  }}
                />
              </div>
            )}
            
            {/* Iframe - only rendered when video should be loaded */}
            {isVideoLoaded && (
              <iframe
                src={"https://player.vimeo.com/video/" + currentVideo.vimeoId + "?loop=0&byline=0&portrait=0&title=0&autoplay=1"}
                width="100%"
                height="100%"
                frameBorder="0"
                allow="autoplay; fullscreen; picture-in-picture"
                allowFullScreen
              />
            )}
            
            {/* Play overlay - only shown when video is not loaded */}
            {!isVideoLoaded && (
              <div className="main-play-overlay">
                <div className="main-play-button">
                  <svg width="100" height="100" viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M100 98.1338L1.86621 100L0 1.86621L98.1338 0L100 98.1338ZM35 69L73 48.5L35 28V69Z" fill="white" fillOpacity="0.5"/>
                  </svg>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>

      <div className="thumbnails-container">
        <div className="thumbnails-scroll">
          {videoData.map((video) => (
            <div
              key={video.id}
              className={`thumbnail-item ${currentVideo.id === video.id ? 'active' : ''}`}
              onClick={() => handleVideoClick(video)}
            >
              <div className="thumbnail-image">
                <img
                  src={video.thumbnail}
                  alt={video.title}
                  loading="lazy"
                />
                <div className="play-overlay">
                  <div className="play-button">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                      <path d="M8 5v14l11-7z" fill="currentColor"/>
                    </svg>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
        <div className="fade-out-indicator"></div>
      </div>
    </section>
  );
};

export default FullWidthVideo;
